import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "./common";

export default function ProtectedRoute({ children, partner = false }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center"><Spinner /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "partner" && !partner) return <Navigate to="/portale" replace />;
  if (user.role !== "partner" && partner) return <Navigate to="/operativo" replace />;
  return children;
}
